import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import BaseButton from "../../../../components/BaseButton";
import Pricing from "../../../../store/Pricing";
import isPayplusDomain from "../../../../utils/isPayplusDomain";
import "./style.scss";

// Плавная изогнутая стрелка (Figma 2419-168): выходит из нижней части набора,
// пересекая рамку, и заворачивает к «Полной игре». Правая зеркалится в CSS.
function PricingArrow() {
  return (
    <svg viewBox="0 0 92 78" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 5C14 30 22 52 44 63C56 69 68 70 80 69"
        stroke="url(#pricing_arrow_grad)"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M80 69L66 65M80 69L73 56"
        stroke="url(#pricing_arrow_grad)"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="pricing_arrow_grad"
          x1="12"
          y1="5"
          x2="80"
          y2="69"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5D38F7" />
          <stop offset="1" stopColor="#E827D9" />
        </linearGradient>
      </defs>
    </svg>
  );
}

// Лендинговый блок тарифов (Figma «Сайт Wepurplay» node 2419-152 / mobile 2432-211).
// Заголовок — Snell Roundhand (рукописный), тексты — Inter Light; рамки карточек —
// тонкие solid (лиловая #C691FB у наборов, фиолетовая #5D38F7 у полной игры).
// Цены доменные (Pricing.format), кнопка каждого набора покупает СВОЙ товар (onBuy).
export default function SectionPricing({ onBuy }) {
  const { t } = useTranslation();

  const cards = [
    {
      key: "test",
      productType: "REPEAT_TEST",
      title: t("section_pricing.test_title"),
      sub: t("section_pricing.test_sub"),
      desc: t("section_pricing.test_desc"),
      price: Pricing.format("REPEAT_TEST"),
    },
    {
      key: "ext",
      productType: "EXTENDED_57",
      title: t("section_pricing.ext_title"),
      sub: t("section_pricing.ext_sub"),
      desc: t("section_pricing.ext_desc"),
      price: Pricing.format("EXTENDED_57"),
    },
  ];

  return (
    <section className="section-pricing">
      <div className="section-pricing__glow" aria-hidden="true" />

      <h2 className="section-pricing__title">
        {t("section_pricing.title")}
      </h2>

      <div className="section-pricing__top">
        {cards.map((c) => (
          <div key={c.key} className="section-pricing__card">
            <h3 className="section-pricing__card-title">{c.title}</h3>
            <p className="section-pricing__sub">{c.sub}</p>
            <p className="section-pricing__desc">{c.desc}</p>
            <BaseButton
              className="section-pricing__price"
              onClick={() => onBuy(c.productType)}
            >
              {c.price}
            </BaseButton>
          </div>
        ))}
      </div>

      <div className="section-pricing__arrows" aria-hidden="true">
        <span className="section-pricing__arrow section-pricing__arrow_left">
          <PricingArrow />
        </span>
        <span className="section-pricing__arrow section-pricing__arrow_right">
          <PricingArrow />
        </span>
      </div>

      <div className="section-pricing__card section-pricing__card_full">
        <h3 className="section-pricing__card-title">
          {t("section_pricing.full_title")}
        </h3>
        <p className="section-pricing__sub">
          <span className="section-pricing__sub-accent">
            {t("section_pricing.full_sub_accent")}
          </span>
          {t("section_pricing.full_sub_rest")}
        </p>
        <p className="section-pricing__desc">
          {t("section_pricing.full_desc", {
            price: Pricing.format("GAME"),
            // экономия доменно-зависимая: $28 на payplus, ₽-эквивалент на .ru
            save: isPayplusDomain() ? "$28" : "2800 ₽",
          })}
        </p>
        <BaseButton
          className="section-pricing__price"
          onClick={() => onBuy("GAME")}
        >
          {Pricing.format("GAME")}
        </BaseButton>
      </div>
    </section>
  );
}

SectionPricing.propTypes = {
  onBuy: PropTypes.func,
};
